export default {
  marker: {
    cursor: 'pointer',
    height: '20px',
    width: '15px',
    transform: 'translateY(-100%) translateX(-50%)',
  },
};
